import { Injectable } from '@angular/core';
import * as jwt_decode from 'jwt-decode';


@Injectable()
export class AuthService {

  public getToken(): string {
    return localStorage.getItem('token');
  }

  // public isAuthenticated(): boolean {
  //   // get the token
  //   const token = this.getToken();
  //   // return a boolean reflecting 
  //   // whether or not the token is expired
  //   return tokenNotExpired(null, token);
  // }

  public setToken(token: string): void {
    localStorage.setItem('token', token);
  }

  public hasToken(): Boolean {
    return localStorage.getItem('token') ? true : false;
  }

  private getTokenExpirationDate(token: string): Date | null {
    const decoded = jwt_decode(token);

    if (decoded.exp === undefined) { return null; }

    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }


  public isTokenExpired(token?: string): boolean {
    if (!token) {
      token = this.getToken();
    }
    if (!token) { return false; }

    const date = this.getTokenExpirationDate(token);

    if (date === undefined) { return false; }
    return !(date.valueOf() > new Date().valueOf());
  }

}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/services/auth.service.ts